<template>
    <div ref="notificationInfo">
        <div v-if="!loading.all" class="row align-items-center justify-content-start w-100">
          <div class="d-flex align-items-center col-md-12">
            <feather-icon
              class="icon-hover mr-2"
              icon="ChevronLeftIcon"
              size="24"
              @click="returnSurveys()"
            />
            <div class="d-flex">
                <h5 class="mb-0" v-if="form.title"><strong>{{ form.title }}</strong></h5>
                <span class="mr-50 ml-50">-</span>
                <span>{{ form.create_date }}</span>
            </div>
            <div class="ml-2">
                <b-badge variant="warning" pill class="custom-badge-graph mr-50">{{ form.total_response }}</b-badge>
                <span>Respuestas</span>
            </div>
          </div> 
          <div class="d-flex align-items-center col-md-12 justify-content-between">
            <li class="ml-4">A continuación se muestran las estadísticas de la encuesta.</li>
            <b-button v-if="false" class="push-right separation-buttons" variant="outline-success" :disabled="loading.excel" @click="downloadExcel()">
              <feather-icon v-if="!download" icon="DownloadIcon"/>
              <i v-else :class="['fa', 'fa-spinner', 'fa-spin']"/>
              {{$t('Exportar excel')}}
            </b-button>
          </div>
          <div class="padding-form-notification col-md-12">
            <charts :questions="form.questions"/>
          </div>
        </div>
        <div v-else class="center-spinner mb-2">
          <b-spinner />
        </div>
    </div>
</template>
<script>
import Charts from './Charts.vue'
import { mapGetters } from 'vuex'
export default {
  props: ['data'],
  components: {Charts},
  data () {
    return {
      form: {
        questions: []
      },
      loading: {
        excel: false,
        all: true
      },
      download: false,
      questions: []
    }
  },
  watch: {
    surveys_graph (value) {
      this.form = value
      this.loading.all = false
    }
  },
  computed: {
    ...mapGetters({
      surveys_graph: 'getSurveysGraph'
    })
  },
  mounted () {
    this.getSurveysGraph()
  },
  methods: {
    returnSurveys () {
      this.$emit('returnSurveys', {list: true, survey: false, resultsGraph: false})
    },
    getSurveysGraph () {
      const queryParams = {
        survey_id: this.data.id
      }
      const params = {}
      this.$store.dispatch('fetchService', { name: 'getSurveysGraph', queryParams, params})
    }
  }
}
</script>
<style>
.custom-badge-graph{
  background-color: #F4BB43;
  padding-right: 0.8rem;
  padding-left: 0.8rem;
}
.center-spinner {
  display: flex;
  justify-content: center;
}
</style>